export const socketGamePath = 'game';
export const gameName = 'wild-weed';
